"use client";

import { VisuallyHidden } from "@radix-ui/react-visually-hidden";
import { useEffect, useState } from "react";

import { Dialog, DialogContent, DialogTitle } from "../shadcn/components/ui/dialog";
import ModalMailingList from "./mailing-list-modal";

export function ScrollModal() {
	const [open, setOpen] = useState(false);
	useEffect(() => {
		const modalHasBeenClosed = localStorage.getItem("mailing-list-modal-closed");
		const timer = setTimeout(() => {
			if (!modalHasBeenClosed) {
				setOpen(true);
			}
		}, 25_000);
		return () => clearTimeout(timer);
	}, []);
	return (
		<>
			<Dialog
				modal={false}
				onOpenChange={(val) => {
					setOpen(val);
					localStorage.setItem("mailing-list-modal-closed", "true");
				}}
				open={open}
			>
				<VisuallyHidden>
					<DialogTitle>Scroll-based Mailing List Modal</DialogTitle>
				</VisuallyHidden>
				<DialogContent className="p-8 !top-auto md:!left-auto bottom-0 left-auto right-0 sm:bottom-4 sm:right-4 lg:right-8 lg:bottom-8 !translate-x-0 !translate-y-0">
					<div className="w-11/12 mx-auto flex flex-col gap-3">
						<h2 className="font-skia uppercase tracking-widest text-xl leading-relaxed">Sign Up to the Mailing List</h2>
					</div>
					<ModalMailingList />
				</DialogContent>
			</Dialog>
		</>
	);
}
